import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./memoryCont.css";
import { deleteMemoryByRecordId } from "../../../services/iqApiV2";
import { listGlobalMemRequest } from "../../../store/features/actions/memory/globalMemoryActions";
import { useUser } from "../../../context/UserContext";
import IOSSpinner from "../../HtmlElements/IOSSpinner";
import TagList from "../../Frontend/genericComponents/tag/TagList";

function MemoryHistoryListComp({memoryType}) {
  const { listGlobalMemDataLoading, listGlobalMemData } = useSelector(
    (state) => state.listGlobalMemDataReducer
  );

  const {  globalMemDataLoading} = useSelector(state=>state.globalMemDataReducer)
  const dispatch = useDispatch();
  const {user} = useUser();


  const handleMemoryDelete = async (e, recordID,memoryType) => {
    e.preventDefault();
    e.stopPropagation();
    const resp = await deleteMemoryByRecordId(recordID);
    if (resp?.status==200 && resp?.deleted_id) {
      dispatch(listGlobalMemRequest({userId:user?.id,memoryType}));
    }
    
  };
  function countSummary(data, keysMap) {
    return Object.entries(keysMap).map(([key, label]) => {
      let count = 0;
      if (key === 'file_details') {
        // Sum all file_details arrays
        count = data?.reduce((sum, item) => sum + (Array.isArray(item[key]) ? item[key].length : 0), 0);
      } else {
        // Count non-empty strings
        count = data?.filter(item => typeof item[key] === 'string' && item[key].trim() !== '').length;
      }
      return { label, count };
    });
  }

  const keysToCheck = {
    prompt: "Instructions",
    file_details: "Documents",
    web_url: "Weblinks"
  };
const [memOverView,setMemOverView]= useState([])
  useEffect(() => {

    const result = countSummary(listGlobalMemData, keysToCheck);
    setMemOverView(result?.map(item=>"("+ item.count +") "+  item.label ))
  }, [listGlobalMemData])
  

  if (listGlobalMemDataLoading||globalMemDataLoading) return <div style={{height:"25rem", display:"flex",justifyContent:"center",alignItems:"center",backgroundColor:"white"}}>
    <IOSSpinner/>
  </div>;

  return (
    <div className="mem-hist-list-container">
      <span className="mem-hist-list-container-titl">My Memories ({listGlobalMemData?.length||0})</span>
      <span> <TagList tags={memOverView}/></span>
      {listGlobalMemData?.map((mem, idx) => (
        <div key={mem.id || idx} className="mem-hist-card">
          <div className="mem-hist-card-header">
            <div className="mem-hist-date">
              {new Date(mem.modified_date).toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "short",
                year: "numeric",
              })}
            </div>
            <img
              src="/img/trash-2.png"
              alt="delete"
              className="mem-hist-delete-icon"
              onClick={(e) => handleMemoryDelete(e, mem.id,memoryType)}
            />
          </div>

          <div className="mem-hist-card-body">
            <div className="mem-hist-field">
              <strong>Instructions</strong>: <span className="span_inst">{mem.prompt || ""}</span>
            </div>

            {mem?.file_details?.length > 0 && (
              <div className="mem-hist-field">
                <strong>Documents</strong>:{" "}
                <ul className="mem-action-file-list">
                  {mem?.file_details?.map((file) => (
                    <li key={file?.file_id} className="mem-action-file-item">
                      <span className="mem-action-file-name ">
                        {file?.file_name}
                      </span>
                    </li>
                  ))}
                </ul>
              </div>
            )}

            {mem?.web_url && (
              <div className="mem-hist-field">
                <strong>Weblink</strong>:{" "}
                <a
                  href={mem.web_url}
                  className="mem-hist-web-link"
                  target="_blank"
                  rel="noreferrer"
                >
                  {mem.web_url}
                </a>
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}

export default MemoryHistoryListComp;
